import { useEffect, useState } from 'react';
import { getInsuranceList } from '../services/plans/listInsurance';

export interface Option {
  label: string;
  value: string;
}

let cachedPayorOptions: Option[] | null = null;
let inFlightRequest: Promise<Option[]> | null = null;

const fetchPayorOptions = (): Promise<Option[]> => {
  if (cachedPayorOptions) {
    return Promise.resolve(cachedPayorOptions);
  }

  if (!inFlightRequest) {
    inFlightRequest = getInsuranceList()
      .then((response) => {
        const uniqueNames = Array.from(
          new Set(
            (response.insurance || [])
              .map((insurance) => insurance.friendlyName)
              .filter((name): name is string => Boolean(name))
          )
        ).sort((a, b) => a.localeCompare(b));

        cachedPayorOptions = uniqueNames.map((name) => ({
          label: name,
          value: name,
        }));
        return cachedPayorOptions;
      })
      .finally(() => {
        inFlightRequest = null;
      });
  }

  return inFlightRequest;
};

export const usePayorOptions = (): Option[] => {
  const [options, setOptions] = useState<Option[]>(
    cachedPayorOptions || []
  );

  useEffect(() => {
    let isMounted = true;

    fetchPayorOptions()
      .then((result) => {
        if (isMounted) {
          setOptions(result);
        }
      })
      .catch((error) => {
        console.error('Failed to load payor options:', error);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return options;
};
